import React from 'react'
import DonationSection from './DonationSection'
import TermsOption from './TermsOption'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import yn from 'yn'

const Sidebar = ({
  creditName,
  creditValue,
  pointsValue,
  donationPointsValue,
  handlerFinalizePayment,
  handlerFinalizeDonation,
  loadingPayment,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  convertedValue,
  validateConversion
}) => (
  <div className='cart-side col-12 col-md-4 mt-3 mt-md-0 px-0 py-0'>
    <div className='border-ui-3 radius bg-white'>
      <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
        <h2 className='h3 color-title txt-font-body'>Resumo da doação</h2>
      </div>
      <div className='cart-subtotal col-12 pb-3 mx-0'>
        <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
          <DonationSection
            creditName={creditName}
            creditValue={convertedValue.toLocaleString('pt-br', {
              minimumFractionDigits: 2
            })}
            donationPointsValue={donationPointsValue}
          />
        </div>
        {yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) && <TermsOption
          acceptTerms={acceptTerms}
          acceptTermsEvent={acceptTermsEvent}
          showTermsEvent={showTermsEvent}
        /> }
        <div className='cart-done row px-2 pt-2'>
          <div className='col-12 justify-content-center align-self-center'>
            {loadingPayment ? (
              <button
                className='btn-featured btn-icon'
                aria-label='Carregando...'
              >
                <div className='btn-loading mr-auto ml-auto'>
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </button>
            ) : (
              <Button
                id='finalize'
                className='btn-featured btn-icon'
                disabled={
                  !loadingPayment &&
                  validButton(acceptTerms, validateConversion)
                }
                text='Finalizar doação'
                iconName='icon_donation'
                onClick={() => handlerFinalizeDonation()}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
)

const validButton = (acceptTerms, validateConversion) => {
  const result = (!yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) || !!acceptTerms) && !!validateConversion

  return !result ? 'true' : 'false'
}

Sidebar.propTypes = {
  creditName: PropTypes.string,
  loadingPayment: PropTypes.bool,
  creditValue: PropTypes.number,
  pointsValue: PropTypes.any,
  handlerFinalizePayment: PropTypes.func,
  acceptTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  acceptTermsEvent: PropTypes.func,
  donationPointsValue: PropTypes.any,
  convertedValue: PropTypes.number,
  handlerFinalizeDonation: PropTypes.func,
  validateConversion: PropTypes.bool
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/features/Donation/Sidebar/Sidebar.js